import { render } from "./UltraPrivacyMessage.vue?vue&type=template&id=e8aa2ae8&scoped=true"
import script from "./UltraPrivacyMessage.vue?vue&type=script&lang=js"
export * from "./UltraPrivacyMessage.vue?vue&type=script&lang=js"

import "./UltraPrivacyMessage.vue?vue&type=style&index=0&id=e8aa2ae8&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8aa2ae8"]])

export default __exports__